var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_780","data-name":"Group 780","transform":"translate(1439.207 2883.207) rotate(180)"},[React.createElement("line",{"id":"Line_177","data-name":"Line 177","x2":"5","y2":"5","transform":"translate(1428.5 2877.5)","fill":"none","stroke":"#383b23","strokeLinecap":"square","strokeWidth":"1","key":0}),React.createElement("line",{"id":"Line_178","data-name":"Line 178","x1":"5","y2":"5","transform":"translate(1433.5 2877.5)","fill":"none","stroke":"#383b23","strokeLinecap":"square","strokeWidth":"1","key":1})]));
}

Chevron.defaultProps = {"width":"11.414","height":"6.414","viewBox":"0 0 11.414 6.414"};

module.exports = Chevron;

Chevron.default = Chevron;
